import { CartItemType } from '../../../types'

export { default as CourseOnlyCheckout } from './CourseOnlyCheckout'
export { default as StyledCourseOnlyCheckout } from './CourseOnlyCheckout.Styled'

export const subscriptionCartItem: CartItemType = {
  itemData: {
    _id: 'course-sub',
    title: 'Social Curator Subscription',
    description: 'Receive two months of access to Social Curator for FREE. Cancel anytime.'
  },
  type: 'subscription'
}
